import Image from 'next/image'
import Link from 'next/link'

type Props = {
  decodingDescription?: string
  eventDate: string
  eventType: string
  decodingVideoLink: string
}

function DecodingAISearch({
  decodingDescription,
  eventDate,
  eventType,
  decodingVideoLink
}: Props) {
  return (
    <section className="bg-[#090909] text-white relative">
      <Image
        src="/assets/index-25/decode-bg-img.png"
        alt="decode-bg-img"
        height="955"
        width="1441"
        className="absolute w-full h-full"
      />
      <div className="container mx-auto relative z-10 py-10 md:py-18">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-6 flex flex-col justify-between order-2 md:order-1">
            <div className="mb-14">
              <h1 className="md:text-5xl font-bold | hidden md:block max-w-xs | mb-22 md:mb-14">
                Index&#39;25
              </h1>
              <h2 className="text-3xl md:text-4xl font-medium mb-4">
                Decoding AI Search:
              </h2>
              <h3 className="text-4xl md:text-5xl font-medium | mb-6 md:mb-10">
                The World’s First GEO Conference
              </h3>
              <p className="text-gray-40 text-base md:text-lg md:max-w-xl lg:pr-18">
                {decodingDescription}
              </p>
            </div>
            <div className="flex flex-col md:flex-row gap-4">
              <Link
                href="#agenda"
                className="flex justify-center items-center flex-nowrap text-sm font-medium border border-white rounded-lg py-2 px-10 w-full md:w-auto"
              >
                View Agenda
              </Link>
              <Link
                href="#invite-only"
                className="bg-linear-to-r from-[#1600E5] to-[#4B77F2] flex justify-center items-center gap-2 flex-nowrap text-sm font-medium rounded-lg py-2 px-10 w-full md:w-auto"
              >
                Register Now
              </Link>
            </div>
          </div>
          <div className="lg:col-start-8 lg:col-span-5 flex flex-col justify-end md:gap-20 order-1 md:order-2">
            <h1 className="text-4xl font-bold | block md:hidden max-w-xs | mb-22 md:mb-14">
              Index&#39;25
            </h1>
            <div className="mb-6">
              <div className="text-base md:text-2xl font-semibold | mb-4 md:mb-6">
                {eventDate}
              </div>
              <div className="text-gray-40 text-caption md:text-base">
                {eventType}
              </div>
            </div>

            {decodingVideoLink ? (
              <iframe
                title="Decoding AI Search Video"
                src={decodingVideoLink}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className={'aspect-video w-full'}
              />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  )
}

export default DecodingAISearch
